<!--
  @description PAAS初始化申请单
  @author xiehan
  @date 2019/01/14
-->
<template>
  <div class="paasInitRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="paasInitRequest@submit"
      :requestTitle="$t('cloudApplication.paasInitRequest')"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center">
        <el-row :gutter="10" style="margin-bottom: 10px;">
          <el-col :span="4">
            <div v-text="'IP'" class="paas-title"></div>
          </el-col>
          <el-col :span="17">
            <div style="padding: 0 8px;">
              <el-row :gutter="10">
                <el-col :span="7">
                  <div v-text="$t('cloudApplication.group2')" class="paas-title"></div>
                </el-col>
                <el-col :span="6">
                  <span style="color: red;">*</span>
                  <div v-text="$t('cloudApplication.app')" class="paas-title"></div>
                </el-col>
                <el-col :span="11">
                  <span style="color: red;">*</span>
                  <div v-text="$t('cloudApplication.version')" class="paas-title"></div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="3">
            <el-button icon="icon-xinzeng"
              type="primary"
              style="width: 70px;"
              @click="addInitList"></el-button>
          </el-col>
        </el-row>
        <el-form ref="paasForm" :model="paasForm" label-width="0" :inline="true">
          <el-row :gutter="10" v-for="(item, index) in paasForm.initList" :key="item.itemKey" style="margin-bottom: 10px;">
            <el-col :span="4">
              <el-form-item input-width="120px">
                <el-select v-model="item.ip" filterable>
                  <el-option
                    v-for="item in select_ip"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="17">
              <div class="middlewareList-wrap">
                <el-row v-for="(_item, _index) in item.middlewareList" :key="_item.itemKey">
                  <el-col :span="7">
                    <el-form-item input-width="144px">
                      <g-select v-model="_item.group" :list="select_group" @change="groupChange(arguments, index, _index)"></g-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item input-width="124px"
                      :prop="'initList.' + index + '.middlewareList.' + _index + '.appName'"
                      :rules="[{ required: true, message: $t('common.chooseTips') + $t('cloudApplication.app'), trigger: 'blur' }]">
                      <g-select v-model="_item.appName" :list="_item.select_app" @change="appChange(arguments, index, _index)"></g-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item input-width="110px"
                      :prop="'initList.' + index + '.middlewareList.' + _index + '.version'"
                      :rules="[{ required: true, message: $t('common.chooseTips') + $t('cloudApplication.version'), trigger: 'blur' }]">
                      <g-select v-model="_item.version" :list="_item.select_version"></g-select>
                    </el-form-item>
                    <el-button icon="icon-xinzeng"
                      type="primary"
                      @click="addMiddlewareList(index)"></el-button>
                    <el-button icon="icon-shanchu1" @click="deleteMiddlewareList(index, _index)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="3">
              <el-button icon="icon-shanchu1"
                style="width: 70px;"
                @click="deleteInitList(index)"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        select_ip: {},
        select_group: {},
        select_operate: {},
        paasForm: {
          initList: [{
            ip: '',
            itemKey: new Date().getTime(),
            middlewareList: [{
              group: '',
              select_app: {},
              select_version: {},
              appName: '',
              version: '',
              itemKey: new Date().getTime()
            }]
          }]
        },
        disAgreeInfo: {},
        processTable: [],
        status: '1'
      }
    },
    components: {
      requestNote
    },
    methods: {
      async waitGroup () {
        await Promise.all([
          this.dGetDictionaryByCode('groupType'),
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
        this.select_group = { ...this.dDictionary.groupType }
        this.paasForm.initList[0].middlewareList[0].group = Object.keys(this.select_group)[0]
        this.waitApp(this.paasForm.initList[0].middlewareList[0].group, 0, 0)
      },
      async waitApp (group, parentIndex, childIndex, fromData = false, appObj) {
        await this.dGetAppByGroup('', group)
        this.paasForm.initList[parentIndex].middlewareList[childIndex].select_app = { ...this.dDictionaryApp[group] }
        if (!fromData) {
          this.paasForm.initList[parentIndex].middlewareList[childIndex].appName =
            Object.keys(this.paasForm.initList[parentIndex].middlewareList[childIndex].select_app)[0]
        } else {
          this.paasForm.initList[parentIndex].middlewareList[childIndex].appName = appObj.appName
        }
        this.getVersion(group, this.paasForm.initList[parentIndex].middlewareList[childIndex].appName,
          parentIndex, childIndex, fromData, appObj)
      },
      getIPList () {
        cmdbBiz.hostList({ perPageCount: 99999 }).then((data) => {
          let ipObj = {}
          if (data && data.dataList && data.dataList.length > 0) {
            data.dataList.map(item => {
              ipObj[item.ip1] = item.ip1
            })
          }
          this.select_ip = ipObj
          this.paasForm.initList[0].ip = Object.keys(this.select_ip)[0]
        })
      },
      getVersion (group, appName, parentIndex, childIndex, fromData = false, appObj) {
        resApplicationBiz.findAllVersion({
          group: group,
          appName: appName
        }).then((data) => {
          let versionObj = {}
          if (data && data.length > 0) {
            data.map(item => {
              versionObj[item] = item
            })
          }
          this.paasForm.initList[parentIndex].middlewareList[childIndex].select_version = versionObj
          if (!fromData) {
            this.paasForm.initList[parentIndex].middlewareList[childIndex].version =
              Object.keys(this.paasForm.initList[parentIndex].middlewareList[childIndex].select_version)[0]
          } else {
            this.paasForm.initList[parentIndex].middlewareList[childIndex].version = appObj.version
          }
        })
      },
      getRequestForm (val) {
        this.$refs['paasForm'].validate((valid) => {
          if (valid) {
            let platformInitList = []
            this.paasForm.initList.map((item, index) => {
              platformInitList.push({
                ip: item.ip,
                middlewareList: []
              })
              item.middlewareList.map(_item => {
                platformInitList[index].middlewareList.push({
                  appName: _item.appName,
                  group: _item.group,
                  version: _item.version
                })
              })
            })
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              platformInitList: platformInitList,
              orderType: val.orderType,
              templateId: val.orderType,
              processInstanceId: val.processInstanceId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitPaasApply(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      addInitList () {
        this.paasForm.initList.push({
          ip: Object.keys(this.select_ip)[0],
          itemKey: new Date().getTime(),
          middlewareList: [{
            group: Object.keys(this.select_group)[0],
            select_app: {},
            select_version: {},
            appName: '',
            version: '',
            itemKey: new Date().getTime()
          }]
        })
        this.waitApp(Object.keys(this.select_group)[0], this.paasForm.initList.length - 1, 0)
      },
      deleteInitList (index) {
        if (this.paasForm.initList.length === 1) return
        this.paasForm.initList.splice(index, 1)
      },
      addMiddlewareList (index) {
        this.paasForm.initList[index].middlewareList.push({
          group: Object.keys(this.select_group)[0],
          select_app: {},
          select_version: {},
          appName: '',
          version: '',
          itemKey: new Date().getTime()
        })
        this.waitApp(Object.keys(this.select_group)[0], index, this.paasForm.initList[index].middlewareList.length - 1)
      },
      deleteMiddlewareList (parentIndex, childIndex) {
        if (this.paasForm.initList[parentIndex].middlewareList.length === 1) return
        this.paasForm.initList[parentIndex].middlewareList.splice(childIndex, 1)
      },
      groupChange (val, parentIndex, childIndex) {
        this.waitApp(val[0].key, parentIndex, childIndex)
      },
      appChange (val, parentIndex, childIndex) {
        this.getVersion(this.paasForm.initList[parentIndex].middlewareList[childIndex].group, val[0].key, parentIndex, childIndex)
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.paasForm.initList = []
          this.disAgreeInfo.info.platformInitList.map((item, index) => {
            this.paasForm.initList.push({
              ip: item.ip,
              itemKey: index,
              middlewareList: []
            })
            item.middlewareList.map((_item, _index) => {
              this.paasForm.initList[index].middlewareList.push({
                group: _item.group,
                select_app: {},
                select_version: {},
                appName: _item.appName,
                version: _item.version,
                itemKey: _index
              })
              this.waitApp(this.paasForm.initList[index].middlewareList[_index].group,
                index, _index, true, { appName: _item.appName, version: _item.version })
            })
          })
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'paasInitRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.$nextTick(() => {
            this.$refs.requestNote.init()
          })
          this.paasForm = {
            initList: [{
              ip: '',
              itemKey: new Date().getTime(),
              middlewareList: [{
                group: '',
                select_app: {},
                select_version: {},
                appName: '',
                version: '',
                itemKey: new Date().getTime()
              }]
            }]
          }
          this.getIPList()
          this.waitGroup()
        } else if (to.name === 'paasInitRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.waitGroup()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      }
      this.waitGroup()
      this.getIPList()
    }
  }
</script>

<style scoped>
  .paas-title {
    height: 33px;
    line-height: 33px;
    display: inline-block;
  }
  .middlewareList-wrap {
    border: 1px solid #e2e2e2;
    padding: 16px 6px 0px 6px;
    border-radius: 6px;
  }
</style>